import { app } from '../../../../app';
import { Controller } from './session-recording-report.controller';

app.component('sessionRecordingReport', {
    controller: Controller,
    templateUrl: require('./session-recording-report.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/session-recording-report/session-recording-report.component.js